import { defineComponent as _defineComponent } from 'vue'
import { LibraryType } from '@/apis/bujianStore/types'
import { buryPoint } from '@/apis/common/buryPoint'
import { analyzeLayout } from '@/apis/work-shop'
import GBaseModal from '@/components/g-base-modal.vue'
import virtualList from '@/components/materialTable'
import { bujianStoreList } from '@/components/materialTable/src/config/tableConfig'
import { From } from '@/data/constant'
import type { PartType } from '@/partTypes'
import router from '@/router'
import store from '@/store'
import { buryPointFunc } from '@/util/buryPointDeal'
import { buryPointApi, genFinalRecord } from '@/util/commonFuncs'
import { operateRecordTableType } from '@/util/configure'
import { dealPreLayoutDataLabelID } from '@/util/dealPaibanData'
import { dealThinkerxMaterialData } from '@/util/dealThinkerxMaterialData'
import { genOrderAddressInfo } from '@/util/plankCommonFuncs'
import {
  findStoreId,
  parseAwaitStoreRenderUrl,
  plankAddAwaitStoreFeature,
  plankAddBujianStoreFeature,
} from '@/views/newPaiban/component/m-paiban-store/utlis'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { nanoid } from 'nanoid'
import {
  computed,
  onMounted,
  reactive,
  ref,
  set,
  withDefaults,
} from 'vue'
import Vue from 'vue'

type Clustering = {
  oId: number
  customer_name: string
  isSelect: boolean
  parts: any[]
  orderNo: string
  address: string
  isUnfold: boolean
}

// 需要在本地查找的type
enum LocalSearchType {
  address = '3',
  customer = '4',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'g-bujian-table',
  props: {
    showDataLength: { default: 12 },
    isManager: { type: Boolean, default: true },
    libraryType: { default: LibraryType.bujianStore },
    selectIds: { default: () => [] },
    preffixID: { default: 'bujian_store' }
  },
  emits: ['onStartLoading', 'onSelectChange'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { showDataLength: number, isManager: boolean, libraryType: LibraryType, selectIds: number[], preffixID: string }




const state = reactive({
  bujianStore: {
    list: [] as any[],
    total: 1,
    page: {
      searchType: '1',
      searchKey: '',
      filterTime: [
        moment().subtract(1, 'month').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      library_type: props.libraryType,
    },
  },
})
const isLoadingStore = ref<boolean>(false)
// 补件仓库被聚类后的数据
const storeClusteringData = ref<{ key: string | number; data: Clustering }[]>()
// 全选
const isSelectAll = ref(true)
// 删除弹窗是否显示
const isVisible = ref(false)
// 当前需要删除的id
const deleteIds = ref<number[]>([])
// 当前需要删除的板件数据，用于生成操作记录
const deleteParts = ref<any[]>([])
// 是否是批量处理操作
const isBatchOpe = ref(false)
const news = ref<any[]>([])
// 最终使用的仓库数据
const storeFinalData = computed(() => {
  const finalData: any[] = []
  storeClusteringData.value?.forEach(({ data }) => {
    const headData = data
    set(headData, 'isVirtualHead', true)
    finalData.push(headData)
    // 展开的情况才将数据push
    if (data.isUnfold) {
      data.parts.forEach((part) => {
        part.matCode = part.is_high_gloss_plank
          ? part.matCode.includes('高光')
            ? part.matCode
            : '高光_' + part.matCode
          : part.matCode
        finalData.push(part)
      })
    }
  })
  return finalData
})

onMounted(() => {
  fetchPlankStore(state.bujianStore.page)
})

// 补件仓库
function handleStoreSelect(data: any, type: string) {
  switch (type) {
    case 'singleMatCode':
      handleSingleMatCodeClick(data)
      break
  }
}
// 全选
function handleStoreSelectAll() {
  storeFinalData.value.forEach((it) => {
    it.isSelect = isSelectAll.value
  })
  emits('onSelectChange', { isSelectAll: true })
}
// 单个材质选择
function handleSingleMatCodeClick(data: Clustering) {
  data.parts.forEach((part: any) => {
    part.isSelect = data.isSelect
  })
  isSelectAll.value = state.bujianStore.list.every((it) => it.isSelect)
  emits('onSelectChange', { isSelectMatCodeAll: true })
}
// 单个板件选择
function handleChangeSelect(singleMatCodeData?: any) {
  if (singleMatCodeData) {
    singleMatCodeData.isSelect = singleMatCodeData.parts.every(
      (it: any) => it.isSelect
    )
  }
  isSelectAll.value = state.bujianStore.list.every((it) => it.isSelect)
  emits('onSelectChange', { isSelectSingle: true })
}

function handleStoreDelete(part?: any) {
  deleteIds.value = [part.id]
  deleteParts.value = [part]
  isVisible.value = true
  isBatchOpe.value = false
  news.value = [part.new ? '1' : '0']
}

function handleStoreBatchDelete() {
  const selects = getSelectData()
  const ids = selects.map((it) => it.id)
  if (!ids?.length) return message.warning('请至少选中一块板件')
  deleteIds.value = ids
  deleteParts.value = selects
  isVisible.value = true
  isBatchOpe.value = true
  news.value = selects.map((it) => (it.new ? '1' : '0'))
}

/** 补件/待排版库删除操作记录（表格形式） */
function saveBujianStoreRecord(deletedParts: any[]) {
  if (!props.isManager) return
  const deleteList = (
    Array.isArray(deletedParts) ? deletedParts : [deletedParts]
  ).filter(Boolean)
  if (!deleteList.length) return

  const isBujianStore = props.libraryType === LibraryType.bujianStore
  const bujianRecordKeys = [
    'address',
    'customer_name',
    'plankID',
    'matCode',
    'texture',
    'sizeStr',
    'plankNum',
    'create_time',
  ]

  genFinalRecord(
    {
      key: '',
      operateArr: [
        {
          key: isBujianStore ? '补件库' : '待排版库',
          dataArr: [
            {
              type: 'table',
              list: [],
              oriList: deleteList,
              keys: bujianRecordKeys,
              tableType: operateRecordTableType.BUJIAN_PLANK_TABLE,
              idKey: 'id',
            },
          ],
        },
      ],
    },
    'supplement-management',
    -2,
    () => {
      console.log('saveBujianStoreRecord', deletedParts)
    }
  )
}

/**
 * 埋点操作
 * @param isBatch 是否是批量
 * @param isDelete 是否是删除
 */
function recordFunc(isBatch: boolean, isDelete = true) {
  // 补件库的埋点
  if (props.libraryType === LibraryType.bujianStore) {
    if (isDelete) {
      //  补件仓库和设备联机(云端生产)分开记录
      if (props.isManager) {
        buryPointFunc(isBatch ? '补件仓库-批量删除' : '补件仓库-删除')
      } else {
        buryPointApi('device_online', 'refstore_delete')
      }
    }
  } else {
    // 待排版库埋点
    // 删除埋点
    if (isDelete) {
      if (isBatch) {
        buryPoint({
          function_module: 'await_store',
          function_point: 'batch_delete',
        })
      } else {
        buryPoint({ function_module: 'await_store', function_point: 'delete' })
      }
    }
  }
}

// 确认删除
function handleConfrimDelete(isBatch: boolean) {
  const params = {
    ids: deleteIds.value.join(','),
    new: news.value.join(','),
  }
  Vue.prototype.$request(
    `/workshop/supplements`,
    {
      params,
      method: 'DELETE',
    },
    (res: any) => {
      if (res.status == 1) {
        message.success('删除成功')
        saveBujianStoreRecord([...deleteParts.value])
        deleteParts.value = []
        state.bujianStore.page.searchKey = ''
        fetchPlankStore(state.bujianStore.page)
        recordFunc(isBatch, true)
      } else {
        message.error(res.msg)
      }
    }
  )
  isVisible.value = false
}

// 生成唯一标识ID
function genPartUniqueId(list: PartType[]) {
  list.forEach((it) => {
    it.partUniqueId = nanoid()
  })
  return list
}

function search(queryParam: Partial<typeof state.bujianStore.page>) {
  state.bujianStore.page = { ...state.bujianStore.page, ...queryParam }
  fetchPlankStore(state.bujianStore.page)
}

async function handleToPaiban(data: any[]) {
  try {
    store.commit('setBeforeSearchMaterialList', null)
    store.commit('setFilterMaterialList', null)
    store.commit('setBeforeSizeFilterList', null)
    store.commit('setFilterObject', null)
    // emits('onStartLoading', {
    //   msg: '正在解析补件数据,请稍等...',
    //   isLoading: true,
    // })
    if (!data.length) {
      recordFunc(true)
      data = getSelectData()
    } else {
      recordFunc(false)
    }
    const layout = await getAnalyzeData(data)
    // 可能会触发的未知错误
    if (!layout) return
    emits('onStartLoading', { msg: '正在进入排版...', isLoading: true })
    const result = layout.data?.plank_data
    const newResult = result.map((it: any) => {
      return {
        ...it,
        id: 1,
      }
    })
    goToMaterialPage(newResult)
    buryPoint({
      function_module: 'supplement',
      function_point:
        newResult.length === 1
          ? 'single_choice_paiban'
          : 'double_choice_paiban',
    })
  } finally {
    emits('onStartLoading', {
      msg: '',
      isLoading: false,
    })
  }
}

/** 待排版库进入料单页面 */
async function handleAwaitStoreToPaiban(planks: any[]) {
  emits('onStartLoading', { msg: '正在进入排版...', isLoading: true })
  const result = await getAwaitStoreAnalyzeData(planks)
  result && goToMaterialPage(result as any)
  recordPaibanStoreId(planks)

  buryPoint({
    function_module: 'await_store',
    function_point:
      planks.length === 1 ? 'choose_single_paiban' : 'choose_batch_paiban',
  })
  emits('onStartLoading', {
    msg: '',
    isLoading: false,
  })
}

/** 获取当前数据解析后的板件数据 */
async function getAwaitStoreAnalyzeData(data: any[]) {
  try {
    const promises = data.map((it) =>
      parseAwaitStoreRenderUrl(it.render_url, it.from)
    )
    const result = await Promise.all(promises)
    result.forEach((plank: PartType) => {
      const target = findStoreId(data, plank, alreadyUseId)
      plankAddAwaitStoreFeature(plank, target)
    })
    alreadyUseId.clear()
    return result
  } catch (err) {
    console.error(err)
    message.error('未知错误')
  }
}

/** 记录参与排版的待排版库板件的id */
function recordPaibanStoreId(data: any[]) {
  // 记录参与排版的待排版库ID
  const ids = data.map((it: any) => it.id)
  // 不加载更多的情况下清空记录的id
  if (!store.state.preferencesSetting?.setting.isLoadMoreTable) {
    store.commit('awaitPaibanStore/clearInMaterialPageIds')
  }
  store.commit('awaitPaibanStore/setInMaterialPageIds', ids)
}

/** 前往料单页面 */
function goToMaterialPage(planks: PartType[]) {
  store.commit('setBeforeSearchMaterialList', null)
  store.commit('setFilterMaterialList', null)
  store.commit('setBeforeSizeFilterList', null)
  store.commit('setFilterObject', null)
  const selectedPlanks = planks.map((plank) => ({ ...plank, isSelected: true }))
  // 根据偏好设置选择覆盖还是添加新的数据
  if (store.state.preferencesSetting?.setting.isLoadMoreTable) {
    planks = [...store.state.preLayoutData, ...selectedPlanks]
  } else {
    planks = selectedPlanks
  }

  // 处理从lbl优化历史中进入云排版，然后使用补件，待排版库进行排版时，板子数据缺失问题
  if (sessionStorage.getItem('thinkerx_material')) {
    sessionStorage.setItem('isHistory', '1')
  }
  const sampleData = genOrderAddressInfo(planks)
  Reflect.deleteProperty(sampleData, 'designer')
  store.commit('setSampleTableData', sampleData)
  store.commit('setPreLayoutData', dealPreLayoutDataLabelID(planks))
  router.push({
    path: '/materialList',
  })
  // 清空排版数据
  store.commit('setPaibanData', [])
}

// 给板件加上补件/待排版库的id可用于后续扣减补件，需要记录使用了的id因为是按照plankId和planknum匹配的可能混出现重复板
const alreadyUseId = new Set()
/**解析板件并返回结果 */
async function getAnalyzeData(data: any[]) {
  const supplements = data.map((it) => {
    const part = originStoreData.value.find((item) => item.id === it.id)
    delete part.partUniqueId
    return part
  })

  const layout = await analyzeLayout(supplements)
  // 可能会触发的未知错误
  if (!layout || layout?.status !== 1) {
    message.error(layout?.msg ?? '出现了未知错误！请联系我们解决')
    emits('onStartLoading', { msg: '错误!', isLoading: false })
    return
  }
  if (layout.data?.plank_data.length) {
    layout.data?.plank_data.forEach((plank: PartType) => {
      const target = findStoreId(data, plank, alreadyUseId)
      plank._isNewTableBujian = target?.new
      plankAddBujianStoreFeature(plank, target)
      plank.partUniqueId = nanoid()
      if (plank.from === From.LBL || plank.from === From.LBLL) {
        Object.assign(plank, dealThinkerxMaterialData([plank])?.[0] ?? plank)
      }
      // 柜柜补件等非 LBL 路径也需补齐，与直跳 srcTexDir=texDir 一致
      plank.srcTexDir = plank.srcTexDir || plank.texDir
    })
    alreadyUseId.clear()
  }
  return layout
}

// 储存原始状态的补件数据
const originStoreData = ref<any[]>([])

// 获取板件仓库数据
function fetchPlankStore(queryParam: typeof state.bujianStore.page) {
  isLoadingStore.value = true
  const { searchKey, filterTime, searchType, library_type } = queryParam
  const params = {
    filter_type: searchType,
    filter_word: searchKey,
    start: filterTime && filterTime[0],
    end: filterTime && filterTime[1],
    library_type,
  }
  Vue.prototype.$getByToken('/workshop/supplements', params, (res: any) => {
    if (res.status == 1) {
      let resultArr = genPartUniqueId(res.data.data)
      const copyResultArr = JSON.parse(JSON.stringify(resultArr))
      state.bujianStore.list = resultArr
      // 保留一份原始的接口数据，在排版时，需要使用原始数据
      originStoreData.value = copyResultArr
      dealBujianData()
      state.bujianStore.total = res.data.total
      handleChangeSelect()
    } else {
      message.error(res.msg)
    }
    isLoadingStore.value = false
  })
}

// 滚动到表格底部
function handleScrollBottom() {
  const { total } = state.bujianStore
  if (state.bujianStore.list.length < total) {
    fetchPlankStore(state.bujianStore.page)
  }
}

// 板件归类
function dealBujianData() {
  const sortStoreArr: { key: string | number; data: Clustering }[] = []
  state.bujianStore.list.forEach((it) => {
    if (!it) return
    // 添加选择框属性
    const isSelect = props.selectIds.includes(it.id)
    set(it, 'isSelect', isSelect)
    let { plate_info } = it
    if (!plate_info || !Object.keys(plate_info).length) return
    // 部分板件的plankNum需要从plate_info字段中获取
    if (plate_info) {
      plate_info = JSON.parse(plate_info)
      plate_info.plankNum && (it.plankNum = plate_info.plankNum)
      plate_info.plKId && (it.plankID = plate_info.plKId)
      plate_info.matCode && (it.matCode = plate_info.matCode)
      plate_info.color && (it.texture = plate_info.color)
      plate_info.size &&
        ((it.oSize = plate_info.size), (it.sizeStr = plate_info.size))
      it.address = plate_info.address || it.address
      it.customer_name = plate_info.customer_name || it.customer_name
      it.new = plate_info.new
      it.from = plate_info.from
      it.is_high_gloss_plank = plate_info.is_high_gloss_plank
    }
    // 接口字段为 order_no，归类对象沿用 orderNo
    const { order_no: orderNo = '', customer_name = '', oid, address = '' } = it
    const target = sortStoreArr.find((it) => it.key === address + customer_name)
    // 进行过滤  地址/客户的搜索只能本地搜索
    const { searchType, searchKey } = state.bujianStore.page
    if (
      [LocalSearchType.address, LocalSearchType.customer].includes(
        searchType as LocalSearchType
      ) &&
      searchKey
    ) {
      const searchFields = {
        [LocalSearchType.address]: it.address ?? '',
        [LocalSearchType.customer]: it.customer_name ?? '',
      }
      if (!searchFields[searchType as LocalSearchType].includes(searchKey)) {
        return
      }
    }
    if (target) {
      target.data.parts.push(it)
    } else {
      sortStoreArr.push({
        key: address + customer_name,
        data: {
          isSelect: false,
          customer_name,
          orderNo,
          oId: oid,
          parts: [it],
          address,
          isUnfold: true,
        },
      })
    }
  })
  // 按照添加时间进行降序
  sortStoreArr.sort((a, b) => {
    const aTime = Math.max(
      ...a.data.parts.map((it) => new Date(it.create_time).getTime()),
      0
    )
    const bTime = Math.max(
      ...b.data.parts.map((it) => new Date(it.create_time).getTime()),
      0
    )
    return bTime - aTime
  })
  // 将补件数据进行聚类
  storeClusteringData.value = sortStoreArr
}

// 添加一个新的补件
function addNewBujian(part: any) {
  const copyPart = JSON.parse(JSON.stringify(part))
  // 给新的补件添加唯一标识，防止一次性重复添加同一块板件时，会出现key重复的问题
  copyPart.partUniqueId = nanoid()
  // 在设备联机(云端生产)中加入补件时的补件数据中缺少new字段，此处手动添加
  copyPart.new = copyPart.new === undefined ? true : copyPart.new
  const {
    plankID,
    plankNum,
    matCode,
    texture,
    oRect,
    thick,
    create_time,
    id,
    render_url,
    address,
    customer_name,
    userName,
  } = copyPart
  const plate_info = {
    plKId: plankID,
    from: 'bluen',
    plankNum: plankNum,
    partUniqueId: part.partUniqueId,
    matCode: matCode,
    color: texture,
    size: `${oRect.height}*${oRect.width}*${thick}`,
    new: true,
    address,
    customer_name: customer_name || userName,
  }
  // 将数据处理成补件数据格式
  const bujianPart = {
    create_time,
    id,
    plate_info: JSON.stringify(plate_info),
    render_url: render_url,
  }
  state.bujianStore.list.unshift(bujianPart)
  originStoreData.value = state.bujianStore.list
  dealBujianData()
}

/** 获取已选中的板件 */
function getSelectData() {
  return storeFinalData.value
    .filter((item) => item.isSelect)
    .filter((i) => !i.parts)
}

/** 组件维护问题，内部提供一些操作，供外部使用 */
expose({
  addNewBujian,
  getSelectData,
  handleToPaiban,
  handleAwaitStoreToPaiban,
  handleStoreDelete,
  handleStoreBatchDelete,
  search,
  getAnalyzeData,
  getAwaitStoreAnalyzeData,
  recordPaibanStoreId,
  goToMaterialPage,
})

return { __sfc: true,LocalSearchType, emits, props, state, isLoadingStore, storeClusteringData, isSelectAll, isVisible, deleteIds, deleteParts, isBatchOpe, news, storeFinalData, handleStoreSelect, handleStoreSelectAll, handleSingleMatCodeClick, handleChangeSelect, handleStoreDelete, handleStoreBatchDelete, saveBujianStoreRecord, recordFunc, handleConfrimDelete, genPartUniqueId, search, handleToPaiban, handleAwaitStoreToPaiban, getAwaitStoreAnalyzeData, recordPaibanStoreId, goToMaterialPage, alreadyUseId, getAnalyzeData, originStoreData, fetchPlankStore, handleScrollBottom, dealBujianData, addNewBujian, getSelectData, GBaseModal, virtualList, bujianStoreList }
}

})